import React, { useState, useEffect, useContext } from "react";
import AccountAddBody from "../components/DataList/AccountAddBody";
import AccountEditTitle from "../components/DataList/AccountEditTitle";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import Logger from "../libraries/Logger";
import { AuthContext } from "../contexts/AuthContext";
import apiClient from "../libraries/ApiClient";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 95%;
  max-height: calc(100% - 50px);
`;

function AccountEdit({ lineUserId }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  const location = useLocation();
  const [sendAccountData, setSendAccountData] = useState(null);
  const [token, setToken] = useState("");
  const [rowId, setRowId] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setRowId(params.get("rowId"));
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    setToken(token);
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;

    if (token === undefined) {
      navigate("/Login");
    }
    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, [location]);

  return (
    <Container>
      <AccountEditTitle
        Mode="Edit"
        rowId={rowId}
        sendAccountData={sendAccountData}
      />
      <AccountAddBody
        Mode="Edit"
        rowId={rowId}
        setSendAccountData={setSendAccountData}
      />
    </Container>
  );
}

export default AccountEdit;
